export default "__VITE_ASSET__De6adz3T__"